import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  span {
    width: 160px;
    color: var(--color-black);
    background: var(--color-primary);

    padding: 8px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 4px;

    opacity: 0;
    transition: opacity 0.4s;

    visibility: hidden;
    position: absolute;

    left: 50%;
    bottom: calc(100% + 12px);

    transform: translateX(-50%);

    z-index: 999;

    &::before {
      content: '';
      border-style: solid;
      border-width: 6px 6px 0 6px;
      border-color: var(--color-primary) transparent;

      top: 100%;
      left: 50%;
      position: absolute;

      transform: translateX(-50%);
    }
  }
  &:hover span {
    opacity: 1;
    visibility: visible;
  }
`;
